// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2sR-C","location":"Header_location__2Htkz"};